import React from 'react';
import { AgentRole } from '../src/types';

interface AgentCardProps {
  role: AgentRole;
  isActive: boolean;
  statusMessage?: string;
  icon: React.ReactNode;
}

const AgentCard: React.FC<AgentCardProps> = ({ role, isActive, statusMessage, icon }) => {
  return (
    <div className={`p-4 rounded-lg border transition-all duration-300 ${
      isActive 
        ? 'bg-cv-elevated border-cv-interactive shadow-[0_0_15px_rgba(113,153,184,0.35)]'
        : 'bg-cv-panel border-cv-border-strong opacity-70'
    }`}>
      <div className="flex items-center space-x-3 mb-2">
        <div className={`p-2 rounded-md ${isActive ? 'bg-cv-interactive' : 'bg-cv-elevated'}`}>
          {icon}
        </div>
        <h3 className="text-lg font-bold text-cv-primary">
          {role === AgentRole.SCRIBE ? 'Draft Writer' :
           role === AgentRole.EDITOR ? 'Style Edit' :
           role === AgentRole.PUBLICATION_EDITOR ? 'Final Polish' :
           role === AgentRole.ARCHIVIST ? 'Story Memory' :
           role === AgentRole.INSPECTOR ? 'Continuity Check' :
           role}
        </h3>
      </div>
      <div className="h-16 overflow-y-auto">
        <p className={`text-sm font-mono ${isActive ? 'text-cv-interactive-hover' : 'text-cv-muted'}`}>
          {isActive ? statusMessage || 'Working...' : 'Idle'}
        </p>
      </div>
      {isActive && (
        <div className="mt-2 w-full h-1 bg-cv-elevated rounded-full overflow-hidden">
          <div className="h-full bg-cv-interactive animate-pulse w-full"></div>
        </div>
      )}
    </div>
  );
};

export default AgentCard;